/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Nug24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Nug 24">
      <path
        fill="#4BA279"
        fillRule="evenodd"
        d="M24 3a3 3 0 0 0-5.535-1.605 5.001 5.001 0 0 0-8.071 1.656 6 6 0 0 0-8.894 7.35 3.001 3.001 0 0 0 .55 5.445 7.003 7.003 0 0 0 6.103 6.103 3.001 3.001 0 0 0 5.446.551 6 6 0 0 0 7.35-8.894 5.001 5.001 0 0 0 1.656-8.07A2.998 2.998 0 0 0 24 3Z"
        className="Main"
        clipRule="evenodd"
      />
      <path
        fill="#4BA279"
        fillRule="evenodd"
        d="M6 19a1 1 0 0 1-1 1 3 3 0 0 0-3 3 1 1 0 1 1-2 0 5 5 0 0 1 5-5 1 1 0 0 1 1 1Z"
        className="Main"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        fillRule="evenodd"
        d="M18 3a1 1 0 0 1-1 1 1 1 0 0 0-1 1 1 1 0 1 1-2 0 3 3 0 0 1 3-3 1 1 0 0 1 1 1ZM6 19a1 1 0 0 1-1 1 3 3 0 0 0-3 3 1 1 0 1 1-2 0 5 5 0 0 1 5-5 1 1 0 0 1 1 1Zm13-3a1 1 0 1 0 0-2 3 3 0 0 0-3 3 1 1 0 1 0 2 0 1 1 0 0 1 1-1Zm-6 3a1 1 0 0 1-1 1 1 1 0 0 0-1 1 1 1 0 1 1-2 0 3 3 0 0 1 3-3 1 1 0 0 1 1 1Zm0-5a1 1 0 1 0 0-2 3 3 0 0 0-3 3 1 1 0 1 0 2 0 1 1 0 0 1 1-1ZM8 6a1 1 0 0 1-1 1 1 1 0 0 0-1 1 1 1 0 0 1-2 0 3 3 0 0 1 3-3 1 1 0 0 1 1 1Zm0 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM20 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM9 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm4-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-1-3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm12 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3-10a1 1 0 1 0 0-2 3 3 0 0 0-3 3 1 1 0 1 0 2 0 1 1 0 0 1 1-1Z"
        className="Details"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Nug24,
  md: Nug24,
  lg: Nug24,
  xl: Nug24,
  xxl: Nug24,
  xxxl: Nug24,
};

export const NugIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'nug-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
